module.exports = __webpack_public_path__ + "img/risk-icon.ca78c26d.svg";